import type { AISkill } from "../types";
import { scheduleManagerSkill, scheduleExceptionSuggesterSkill, alarmManagerSkill } from "./index";

export type SkillType = "schedule_manager" | "schedule_exception_suggester" | "alarm_manager";

const skillRegistry: Record<SkillType, AISkill> = {
  schedule_manager: scheduleManagerSkill,
  schedule_exception_suggester: scheduleExceptionSuggesterSkill,
  alarm_manager: alarmManagerSkill,
};

export function getSkill(skillType: SkillType): AISkill {
  return skillRegistry[skillType];
}

export function getAvailableSkillTypes(): SkillType[] {
  return Object.keys(skillRegistry) as SkillType[];
}
